import { Box, Button } from '@bcp-nextgen-dx-component-factory/design-system';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';

interface DrawerFooterProps {
	onAcceptAllCookies?: () => void;
	onSavePreferences?: () => void;
}

export const DrawerFooter = ({ onAcceptAllCookies, onSavePreferences }: DrawerFooterProps) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				alignItems: 'center',
				alignSelf: 'end',
				p: UIHelper.rem(24, 32),
				gap: UIHelper.rem(16),
			}}
		>
			<Button onPress={onAcceptAllCookies}>{t('drawers.cookiesPreferences.button.acceptAll')}</Button>
			<Button onPress={onSavePreferences}>{t('drawers.cookiesPreferences.button.savePreferences')}</Button>
		</Box>
	);
};
